export const GROQ_API_KEY = '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';
export const GROQ_API_URL = 'https://api.groq.com/openai/v1/chat/completions'; 